
import { defineComponent, inject, onMounted, PropType, reactive, ref, watch } from 'vue';
import { dataKey, State, WidgetSpacer, ListWidget } from '../types';
import apportion from '../util/apportion';

export default defineComponent({
	props: {
		me: { type: Object as PropType<WidgetSpacer>, required: true },
	},
	setup(props) {
		const myDOM = ref<HTMLElement>();
		const me = reactive(props.me);
		const state: State = inject<any>(dataKey.STATE);
		const selectCurWidget = (e: MouseEvent) => {
			e.stopPropagation();
			e.preventDefault();
			state.curWidget = me;
		};

		onMounted(() => {
			const target = myDOM.value as HTMLElement;
			const rootWidget = state.rootWidget as ListWidget;
			apportion(rootWidget);

			let lastLen = me.attrs.length;
			watch(
				me,
				value => {
					target.style.width = value.size.width ? value.size.width + 'px' : '';
					target.style.height = value.size.height ? value.size.height + 'px' : '';
					if (lastLen !== value.attrs.length) {
						lastLen = value.attrs.length;
						apportion(rootWidget);
					}
				},
				{ deep: true, immediate: true }
			);
		});
		return { selectCurWidget, myDOM };
	},
});
